import BackToYachtButton from "src/components/shared/BackToYachtButton/BackToYachtButton";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import LinkCards from "src/components/shared/LinkCards/LinkCards";
import { useGetApi } from "src/hooks";
import { PageContainer } from "src/styled";

interface Props {
  section?: string;
  sect?: string;
}

const SettingsCardsPage = ({ section, sect }: Props) => {
  const { data, isLoading } = useGetApi<any>({
    request: "get-settings",
    body: sect ? { params: { sect } } : undefined,
  });
  return (
    <PageContainer>
      <Breadcrumbs>
        <BackToYachtButton fetchLinks />
      </Breadcrumbs>
      <LinkCards
        content={data?.data?.content}
        loading={isLoading}
        pathPrefix={["settings", section]}
        useSectForPath
      />
    </PageContainer>
  );
};

export default SettingsCardsPage;
